module.exports = __webpack_public_path__ + "static/media/not-found.ae01542b.png";